/* Copyright (c) 2017 Backpack Health LLC */

import React, { FC } from 'react';

import GroupLogo from './GroupLogo';
import I18nText from '../../components/I18nTranslation';
import { GroupMetadataType } from '../../../models/GroupMetadata';

interface Props {
  group: GroupMetadataType;
  name: any;
  organizationName: any;
  withOrganizationName: boolean;
  size?: string;
  color: string;
}
const GroupTitleTemplate: FC<Props> = (props) => {
  const size = props.size || '40px';
  return (
    <div className="cmp-grouptitle">
      <GroupLogo group={props.group} size={size} backgroundColor={props.color} />

      <div className="cmp-grouptitle-name">
        <div>
          <div><I18nText data={props.group.name} /></div>
          <div className="cmp-grouptitle-organizationname font-caption font-color-gsMedDark">
            {
              props.withOrganizationName && <I18nText data={props.group.organization_name} />
            }
          </div>
        </div>
      </div>
    </div>
  );
};

export default GroupTitleTemplate;
